// HomeServicesCards.js
import React from 'react';
import { Card, CardContent, Typography, IconButton, Box } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import {
  image3, image4, image6, image5, image7, image8, image9, image10,
  image11, image12, image13, image14, image15, image16, image17
} from './ImageConstants';

const HomeServicesCards = ({ navigate }) => {
  const cardStyle = {
    backgroundColor: '#d8ccba',
    borderTopLeftRadius: '24px',
    borderBottomRightRadius: '24px',
    overflow: 'hidden',
    height: 150,
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.7)',
    cursor: 'pointer',
    transform: 'perspective(1000px)',
    transition: 'transform 0.4s ease, box-shadow 0.4s ease',
    '&:hover': {
      transform: 'perspective(1000px) scale(1.03) rotateX(2deg)',
      boxShadow: '0 12px 24px rgba(0, 0, 0, 0.35), 0 10px 10px rgba(0, 0, 0, 0.25)',
    },
  };

// HomeServicesCards.js - Update the onClick navigation
const services = [
  { title: 'Paintings', image: image3, profession: 'Painting' },
  { title: 'Electrical', image: image4, profession: 'Electrical' },
  { title: 'Plumbing', image: image6, profession: 'Plumbing' },
  { title: 'Tiles & Granite Repair works', image: image5, profession: 'Tiles & Granite Repair' },
  { title: 'Carpenter', image: image7, profession: 'Carpenter' },
  { title: 'AC installation', image: image8, profession: 'AC Technician' },
  { title: 'Gardener', image: image9, profession: 'Gardener' },
  { title: 'UPVC Aluminium Fabrication', image: image10, profession: 'Aluminium Fabrication' },
  { title: 'Packings and Movers', image: image11, profession: 'Packers and Movers' },
  { title: 'Gas Pipeline Installation & Repair', image: image12, profession: 'Gas Pipeline Installation' },
  { title: 'Steel Fabrications', image: image13, profession: 'Steel Fabrication' },
  { title: 'Home Clean', image: image14, profession: 'Home Cleaning' },
  { title: 'Toilet & Kitchen Cleaning', image: image15, profession: 'Kitchen/Toilet Cleaning' },
  { title: 'Sofa & Curtain Installation & Cleaning', image: image16, profession: 'Sofa & Curtain Cleaning' },
  { title: 'Homemaid', image: image17, profession: 'Housekeeping' },
];



  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: 2,
      }}
    >
      {services.map((service, index) => (
       // In the Card onClick:
<Card
  key={index}
  onClick={() => navigate('/home-service-type', { state: { profession: service.profession } })}
  sx={cardStyle}
>
          <Box
            sx={{
              height: '65%',
              border: '1px solid black',
              backgroundImage: `url(${service.image})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              borderBottomRightRadius: '24px',
              position: 'relative',
              boxShadow: '0 8px 12px rgba(0, 0, 0, 0.3)',
              '&::after': {
                content: '""',
                position: 'absolute',
                bottom: 0,
                left: 0,
                width: '100%',
                height: '8px',
                borderBottomRightRadius: '24px',
                zIndex: 2,
              },
            }}
          />
          <CardContent
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              height: '35%',
              px: 1.5,
              py: 0.5,
              backgroundColor: '#d8ccba',
            }}
          >
            <Typography
              variant="body2"
              fontWeight="600"
              color="#333"
              sx={{
                fontSize: '0.88rem',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {service.title}
            </Typography>
            <IconButton sx={{ color: '#333', p: 0.5 }}>
              <ArrowForwardIosIcon fontSize="small" />
            </IconButton>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default HomeServicesCards;